<template>
  <div class="admin-history-activiy">
    <h1>{{ $t('teamTaskDetail.userOrderStatus') }}</h1>
    <div class="fsb">
      <div class="right-container fc" :key="teamtaskDetail.customer.id">
        <div class="user-icon">
          <img
            class="img-fluid"
            v-if="teamtaskDetail.customer.icon !== '' && teamtaskDetail.customer.icon !== null"
            :src="teamtaskDetail.customer.icon"
            alt="avatar"
            width="35"
            height="35"
          />
          <img class="img-fluid" v-else src="../../../assets/images/users/default.png" alt="avatar" width="35" height="35" />
        </div>
        <div class="user-content">
          <h2 class="username">{{ teamtaskDetail.customer.fullName }}</h2>
          <span class="title">{{teamtaskDetail.customer.description}}</span>
        </div>
      </div>
      <div class="left-container">
        <div class="user-phone">
          <!-- number must be dynamic -->
          <div class="fcc">
            <p class="user-phone">{{ teamtaskDetail.customer.summery }}</p>
            <!-- <p class="user-phone">{{ $t('login.phoneNumber') }} <span>09026428483</span></p> -->
            <!-- <Dropdown :items="simpleItems" simpleDropdown menuClass="__menu__dropdown" /> -->
          </div>
        </div>
      </div>
    </div>
    <!-- <p class="order-number">{{ $t('teamTaskDetail.orderNumber') }} <span>213215</span></p> -->
    <div class="mt-2 fcsb">
      <Status :status="teamtaskDetail.status" color="#F1B44C" />
      <Priorities @priorityUpdated="updatePriority($event)" :items="items" />
    </div>
    <div class="order-status fc mt-2">
      <p>{{ $t('teamTaskDetail.orderStatus') }}:</p>
      <p>
        <span>50</span>
        <span>/</span>
        <span class="active-order-status">25</span>
      </p>
    </div>
    <div class="progress-wrapper">
      <ProgressBar :data="ProgressBarsList" />
    </div>
    <div class="pt-2 pb-1">
      <Status title :status="teamtaskDetail.status" />
    </div>
  </div>
</template>

<script>
import { teamTaskMixins } from '../../../utils/mixins'
import TeamTaskDataprovider from '../../../services/teamtask'
import ProgressBar from '../progressbars/ProgressBar'
// import Dropdown from '../Dropdown'
import Priorities from '../Priorities.vue'
import Status from '../Status.vue'
export default {
  mixins: [teamTaskMixins],
  components: {
    // Dropdown,
    ProgressBar,
    Priorities,
    Status,
  },
  data() {
    return {
      items: [
        { id: 2, value: 'الویت خیلی بالا', img: 'fa-regular fa-chevrons-up', color: '#E3726E' },
        { id: 1, value: 'الویت  بالا', img: 'fa-regular fa-chevron-up', color: '#E3726E' },
        { id: 0, value: 'متوسط', img: 'fa-regular fa-minus', color: '#FFAB00' },
        { id: -1, value: 'الویت پایین', img: 'fa-regular fa-chevron-down', color: '#556EE6' },
        { id: -2, value: 'الویت خیلی پایین', img: 'fa-regular fa-chevrons-down', color: '#556EE6' },
      ],
      simpleItems: [
        { id: 1, value: 'تست یک' },
        { id: 2, value: 'تست ذو' },
        { id: 3, value: 'تست سه' },
        { id: 4, value: 'تست چهار' },
      ],
      ProgressBarsList: [
        {
          id: 1,
          value: '69',
          height: '5px',
          color: '#556BE6',
        },
      ],
    }
  },
  methods: {
    updatePriority(payload) {
      TeamTaskDataprovider.updatePriority({
        key: this.$route.params.id,
        priority: payload.new.id,
        oldPriority: payload.old.id
      })
        .then(res => {
         this.$emit('updatePriority',true)
        })
        .catch(err => {
          
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/globalCss.scss';
@import '../../../design/custom/components/_admin_activity_history.scss';
::v-deep .shadow.position-absolute.p-1 {
  padding: 15px !important;
}
::v-deep .statusTextDiv {
  margin: 2px 0 0 0 !important;
}
</style>
